export const PHOTOS_ANIMATION_DURATION = 150;
export const SWIPE_CONFIDENCE_THRESHOLD = 10000;
